import { CarrierFormFields } from '../../../details/actions/carrier-form-fields.component';
import { CarrierFormModal } from '../../../details/actions/carrier-form-modal.component';
import { AddCarrierActionProps, useAddCarrierAction } from './add-carrier-action.hook';

/** The rest of the carrier is set up on its page, which the caller opens on success. */
export function AddCarrierModal(props: AddCarrierActionProps) {
  const { state, loading, error, handlers, control, handleSubmit, image, onImageUploaded } = useAddCarrierAction(props);

  return (
    <CarrierFormModal
      title="Add carrier"
      saving={state.saving || loading}
      error={error}
      onCancel={handlers.onCancel}
      onSubmit={handleSubmit(handlers.onSubmit)}
    >
      <CarrierFormFields control={control} image={image} onImageUploaded={onImageUploaded} />
    </CarrierFormModal>
  );
}
